import React from "react";

const Java_cbrt = () => {
  return (
    <div>
      <h1>Java cbrt</h1>
      <p>This page provides explanations, examples, and common use-cases for Java cbrt in Java.</p>
    </div>
  );
};

export default Java_cbrt;
